import axios from "axios";
import { getEnvVariables } from "../helpers";
import { getKml } from "./storeApi";

const { GOOGLE_API_KEY } = getEnvVariables()

export const UBICACION_OK = "ok";
export const UBICACION_NO_UBICADA = "no_ubicada";
export const UBICACION_SIN_COBERTURA = "sin_cobertura";

export const MENSAJE_DIRECCION_NO_UBICADA = "No pudimos ubicar la dirección. Revísala e inténtalo de nuevo.";
export const MENSAJE_DIRECCION_SIN_COBERTURA = "En este momento no contamos con cobertura en tu dirección. Te invitamos a montar tu pedido y recoger en la tienda más cercana";

const RESPUESTA_SIN_RESULTADOS = { data: { results: [] } };

export const getInfoMap = async (infoAddress) => {
    try {
        let address = infoAddress.replace(/\s/g, "%20");
        address = address.replace(/#/g, "%20");
        const URL = `https://maps.googleapis.com/maps/api/geocode/json?key=${GOOGLE_API_KEY}&address=${address}`;
        console.log(URL);
         const response = await axios.get(URL);
        if(response)
        return response;
        return RESPUESTA_SIN_RESULTADOS;
    } catch (error) {
        console.log("Error al consultar informacion de direccion", error);
        return RESPUESTA_SIN_RESULTADOS;
    }
}

export const ubicarDireccion = async (address) => {
    const response = await getInfoMap(address);
    const results = response?.data?.results;
    if (!Array.isArray(results) || results.length === 0) {
        return { estado: UBICACION_NO_UBICADA };
    }
    const primero = results[0];
    if (primero?.geometry?.location_type === "APPROXIMATE") {
        return { estado: UBICACION_NO_UBICADA };
    }
    const lat = primero?.geometry?.location?.lat;
    const lng = primero?.geometry?.location?.lng;
    if (lat == null || lng == null) {
        return { estado: UBICACION_NO_UBICADA };
    }
    const tienda = await getKml(lat, lng);
    if (!tienda?.id) {
        return { estado: UBICACION_SIN_COBERTURA, lat, lng };
    }
    return { estado: UBICACION_OK, lat, lng, tiendaId: tienda.id };
}

export default { getInfoMap, ubicarDireccion };